import React from 'react';
import ReactDOM from 'react-dom/client';
import Book from './Components/Book';

const root = ReactDOM.createRoot(document.getElementById("block-lambo-content") as HTMLElement);

if (drupalSettings.lambo_online_uitgave.book_data === undefined) {
  root.render(<></>);
}

else {
  root.render(
    <React.StrictMode>
      <Book data={drupalSettings.lambo_online_uitgave} />
    </React.StrictMode>
  );
}

